import { extendZodWithOpenApi } from '@asteasolutions/zod-to-openapi'
import * as zod from 'zod'

import { Day } from './day.js'

// Even though we don't use .openapi() in our code and zod-to-openapi v8 release notes claim
// that extendZodWithOpenApi is not needed, schema generation can still crash without it.
extendZodWithOpenApi(zod)

export const customZod = {
    day: () => zod.custom<Day>((value) => value instanceof Day).meta({ type: 'string', format: 'date' }),

    /**
     * zod.url() also accepts javascript: urls, which can be unsafe
     * @see https://github.com/colinhacks/zod/issues/2353
     *
     * This verifies that the URL starts with http:// or https://
     */
    httpUrl: () => zod.url().regex(/^https?:\/\//),
}
